import { Expose, Type } from 'class-transformer';
import { Truck } from './truck.model';
import { ProductType } from '../../shipments/models/product-type.model';

export class TruckHasShipment extends Truck {
  @Expose()
  shipmentId?: number;

  @Type(() => ProductType)
  @Expose()
  productType?: ProductType;
}
